import { render, staticRenderFns } from "./ConfiguracaoGeralLogicaModal.vue?vue&type=template&id=20f2e188&scoped=true"
import script from "./ConfiguracaoGeralLogicaModal.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoGeralLogicaModal.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoGeralLogicaModal.vue?vue&type=style&index=0&id=20f2e188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f2e188",
  null
  
)

export default component.exports